
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class StockCountField extends Vue {
  @Prop()
  placeholder?: string;

  @Prop()
  value?: any;

  @Prop()
  multiple?: boolean;

  @Prop()
  filterable?: boolean;

  @Prop()
  allowCreate?: boolean;

  @Prop()
  readonly?: boolean;

  val = '';

  options = [
    {
      value: '1',
      label: '单店核销',
    },
    {
      value: '2',
      label: '多店核销',
    },
  ];

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }


  @Watch('val')
  watchInternalVal(): void {
    this.$emit('update', this.val);
  }

  mounted() {
    this.watchValue();
  }
}
